export const capitalizeText = (text: string) => {
	let ref = text || '';
	return ref.length === 1 ? ref.charAt(0).toUpperCase() : ref.charAt(0).toUpperCase() + ref.slice(1);
};
